const ConsentInfoBlock = () => {
    return (
        <div
            className="flex justify-center space-x-2"
        >
            <a
                href="https://skorstensgaard.dk/privatlivspolitik"
                className="hover:underline"
            >
                Privatlivspolitik
            </a>
            <span >
                -
            </span>
            <a
                href="https://skorstensgaard.dk/cookies"
                className="hover:underline"
            >
                Cookies
            </a>
        </div>
    )
}

export default ConsentInfoBlock;